import * as msal from '@azure/msal-browser';
export async function setupMSAL() {
    console.log('setupMSAL');
    const msalConfig = {
        auth: {
            clientId: '1521397d-4b76-46bf-8453-0fe086cc381a',
            authority: 'https://login.microsoftonline.com/common',
            redirectUri: 'https://udv.picit.dk/web3' //TODO: change to correct redirectUri
        },
        cache: {
            cacheLocation: 'sessionStorage',
        },
    };
    const msalInstance = new msal.PublicClientApplication(msalConfig);
    await msalInstance.initialize();
    return msalInstance;
}
export async function loginMSALPopup(msalInstance) {
    try {
        const loginRequest = {
            scopes: ['user.read', 'openid', 'profile', 'email'],
        };
        const loginResponse = await msalInstance.loginPopup(loginRequest);
        return loginResponse;
    }
    catch (error) {
        console.error('error', error);
    }
}
//wip
async function logoutMSAL(msalInstance) {
    console.log('logoutMSAL');
    await msalInstance.logoutRedirect();
}
//wip
async function acquireTokenSilent(msalInstance) {
    console.log('acquireTokenSilent');
    const tokenRequest = {
        scopes: ['user.read', 'openid', 'profile', 'email'],
    };
    try {
        const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);
        console.log('tokenResponse', tokenResponse);
        return tokenResponse;
    }
    catch (error) {
        console.error('error', error);
        if (error instanceof msal.InteractionRequiredAuthError) {
            // fallback to interaction when silent call fails
            return await msalInstance.acquireTokenRedirect(tokenRequest);
        }
    }
}
//wip
async function getUser(accessToken) {
    console.log('getUser');
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${accessToken}`);
    const options = {
        method: 'GET',
        headers: headers,
    };
    const response = await fetch('https://graph.microsoft.com/v1.0/me', options);
    const data = await response.json();
    console.log('data', data);
    return data;
}
//# sourceMappingURL=SSO.js.map